import { render } from "./MentionsTab.vue?vue&type=template&id=00f4b55a&scoped=true"
import script from "./MentionsTab.vue?vue&type=script&lang=js"
export * from "./MentionsTab.vue?vue&type=script&lang=js"

import "./MentionsTab.vue?vue&type=style&index=0&id=00f4b55a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f4b55a"]])

export default __exports__